import * as Config from '../../../../config';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import GridFull from './GridFull';
import CardPartial from '../../common/CardPartial';
import CardLoading from '../../common/CardLoading';
import Spinner from '../../common/Spinner';

import useCharts from '../../../../hooks/useCharts';
import useNCCharts from '../../nav-control/hooks/useNCCharts';

function GridGenres({
  allLabel = null, allTo = null, className, hasPagination = false, height, id, pathApi, rowCount, title, width, perPage,
  showLoading, showTitle = false, customReduceFormat = null, rowHeight = Config.GRID_ROW_HEIGHT,
  hasPaginationV2 = false, arrowRightStyle = null, arrowLeftStyle = null
}) {
  const props = { allLabel, allTo, className, hasPagination, height, id, pathApi, rowCount, title ,width, perPage, hasPaginationV2, arrowRightStyle, arrowLeftStyle }
  const perPageCal = perPage ?? Math.floor(width / Config.CARD_WIDTH) * rowCount;
  const [dataHook] = useCharts(id, pathApi, perPageCal, 'CHART', customReduceFormat);
  const [cancelLoading, setCancelLoading] = useState(false);

  useNCCharts(id, (dataHook && dataHook.items) ? dataHook.items : null);

  useEffect(() => {
    setCancelLoading(false)
  }, [id])

  useEffect(() => {
    setTimeout(() => {
      if (dataHook && dataHook.itemsFull && dataHook.itemsFull.length === 0) {
        setCancelLoading(true);
      }
    }, 1500)
  }, [dataHook])

  return (dataHook && dataHook.itemsFull && dataHook.itemsFull.length > 0)
    ? <GridFull
        {...props}
        rowHeight={rowHeight}
        gutter={{ top: 4, left: 4, width: 8 }}
        dataHook={dataHook}
        element={ <CardPartial showTitle={showTitle} /> }
        loadingElement={ <CardLoading /> }
      />
    : ((showLoading && !cancelLoading) ? <Spinner /> : null)
}

GridGenres.propTypes = {
  id: PropTypes.string.isRequired,
  width: PropTypes.any,
  height: PropTypes.number.isRequired,
  title: PropTypes.string,
  pathApi: PropTypes.string.isRequired,
  hasFilters: PropTypes.bool,
  filtersStyle: PropTypes.object,
  forceHeight: PropTypes.number,
  rowCount: PropTypes.number,
  rowHeight: PropTypes.number,
  columnCount: PropTypes.number,
  hasPagination: PropTypes.bool,
  perPage: PropTypes.number,
  allTo: PropTypes.any,
  style: PropTypes.object,
  showTitle: PropTypes.bool
}

export default GridGenres;
